/* /plans interactions without React hydration, server actions, or new trackers. */
(() => {
	const root = document.querySelector('[data-v3]');
	if (!root) return;
	const analytics = window.YPAnalytics;
	const currentMarket = root.dataset.ypMarket || 'AE';
	const currentPage = root.dataset.ypPage || 'tiers';
	const currentLanguage = document.documentElement.lang === 'ar' ? 'ar' : 'en';
	const nativeCountry = document.querySelector('[data-yp-current-country]')?.dataset.ypCurrentCountry;
	const setReturnTo = (form, value) => form.querySelectorAll('[name="return_to"]').forEach(input => { input.value = value; });
	document.querySelectorAll('.yp-express-country-form').forEach(form => form.addEventListener('submit', () => setReturnTo(form, window.location.pathname + window.location.search)));
	const selectLocale = (market, lang) => {
		try { localStorage.setItem('v3-lang', lang); } catch {}
		const url = new URL(window.location.href);
		if (url.searchParams.has('market') && ['home','plans','tiers'].includes(currentPage)) url.searchParams.set('market', market);
		url.searchParams.set('view', 'yp-' + currentPage + (market === 'AE' ? '' : '-' + market.toLowerCase()) + (lang === 'ar' ? '-ar' : ''));
		const form = document.getElementById('yp-express-localization');
		if (!form) return;
		form.elements.namedItem('country_code').value = currentPage === 'welcome' ? (nativeCountry || market) : market;
		setReturnTo(form, url.pathname + url.search);
		form.requestSubmit();
	};
	try {
		const params = new URLSearchParams(window.location.search);
		const storedLanguage = localStorage.getItem('v3-lang');
		const language = !params.has('view') && ['en','ar'].includes(storedLanguage) ? storedLanguage : currentLanguage;
		const requestedMarket = params.get('market')?.toUpperCase();
		const market = ['home','plans','tiers'].includes(currentPage) && ['AE','KW','QA'].includes(requestedMarket) ? requestedMarket : currentMarket;
		if (language !== currentLanguage || market !== currentMarket) { selectLocale(market, language); return; }
		localStorage.setItem('v3-lang', currentLanguage);
	} catch {}
	// A shared regional link must set the same native buyer country as the menu.
	// Attempt once per destination; if cookies/storage are blocked, keep the
	// visible localization fallback available instead of creating a reload loop.
	try {
		const country = document.querySelector('[data-yp-current-country]')?.dataset.ypCurrentCountry;
		const key = 'yp-country-sync';
		if (currentPage !== 'welcome' && country && country !== currentMarket) {
			if (sessionStorage.getItem(key) !== currentMarket) {
				sessionStorage.setItem(key, currentMarket);
				selectLocale(currentMarket, currentLanguage);
				return;
			}
		} else {
			sessionStorage.removeItem(key);
		}
	} catch {
		// The explicit country form remains usable without browser storage.
	}
	// Shopify inserts its unbranded button asynchronously. Change only the idle
	// label in its exposed light DOM; retain the native element and click handler.
	// Wallet buttons, their shadow DOM and processing/error labels stay untouched.
	root.querySelectorAll('.yp-express-payment[data-buy-label]').forEach(payment => {
		const label = payment.dataset.buyLabel;
		const brandBuyLabel = () => {
			const button = payment.querySelector('shopify-buy-it-now-button[slot="button"] .shopify-payment-button__button--unbranded');
			if (!button || button.disabled || button.getAttribute('aria-busy') === 'true') return;
			if (!['Buy it now', 'اشتر الآن', 'اشترِ الآن'].includes(button.textContent.trim())) return;
			button.textContent = label;
		};
		brandBuyLabel();
		new MutationObserver(brandBuyLabel).observe(payment, {childList: true, subtree: true, characterData: true});
	});
	const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
	const scrollToCatalog = () => (document.getElementById('catalog') || document.getElementById('tabby-plans') || document.getElementById('long-plans'))?.scrollIntoView({behavior: reduced.matches ? 'auto' : 'smooth', block: 'start'});
	const header = root.querySelector('.v3-header');
	const updateHeader = () => header?.setAttribute('data-scrolled', String(window.scrollY > 8));
	window.addEventListener('scroll', updateHeader, {passive: true});
	updateHeader();
	const sections = root.querySelectorAll('.v4-hero, .v4-catalog, .v3-killer-usp, .v3-how, .v3-top5, .v3-reviews, .v3-faq, .v3-final, .v3-welcome, .tabby-hero, .tabby-catalog, .tabby-savings, .tabby-final, .long-plans-hero, .long-plans-savings, .long-plans-final');
	if ('IntersectionObserver' in window && !reduced.matches) {
		const observer = new IntersectionObserver(entries => entries.forEach(entry => {
			if (entry.isIntersecting) { entry.target.dataset.revealed = 'true'; observer.unobserve(entry.target); }
		}), {rootMargin: '0px 0px -10% 0px'});
		sections.forEach(section => { section.dataset.revealed = 'false'; section.dataset.revealReady = 'true'; observer.observe(section); });
	}
	root.querySelectorAll('.v4-hero-cta > button, .v3-final-cta, .tabby-hero button, .tabby-final button, .long-plans-hero button, .long-plans-final button').forEach(button => button.addEventListener('click', () => {
		const label = button.closest('.v4-hero') ? 'v4_hero_get_gift_card'
			: button.closest('.tabby-hero') ? 'tabby_hero_choose_plan'
			: button.closest('.tabby-final') ? 'tabby_final_choose_plan'
			: button.closest('.long-plans-hero') ? 'long_plans_hero_get_subscription'
			: button.closest('.long-plans-final') ? 'long_plans_final_get_yango_play' : null;
		if (label) analytics?.trackButtonClick(label);
		scrollToCatalog();
	}));
	root.querySelectorAll('button[data-yp-buy-url]').forEach(button => button.addEventListener('click', () => {
		if (button.disabled) return;
		const url = button.dataset.ypBuyUrl;
		const sku = analytics?.checkoutSku(url);
		if (sku) {
			if (sku.country === 'AE') analytics.trackButtonClick(`plans_buy_${sku.tier.toLowerCase()}`);
			else {
				const plan = `standard_${sku.duration.toLowerCase()}`;
				analytics.trackButtonClick(`market_buy_${sku.country.toLowerCase()}_${plan}`);
				analytics.trackButtonClick(`market_checkout_${sku.country.toLowerCase()}_${plan}`);
			}
			analytics.trackCheckoutStart(sku);
		}
		window.location.assign(analytics?.decorateCheckoutURL(url) || url);
	}));
	root.querySelectorAll('.v3-faq-summary').forEach(button => button.addEventListener('click', () => {
		const open = button.getAttribute('aria-expanded') !== 'true';
		button.setAttribute('aria-expanded', String(open));
		button.closest('.v3-faq-item').dataset.open = String(open);
		document.getElementById(button.getAttribute('aria-controls'))?.setAttribute('aria-hidden', String(!open));
	}));
	root.querySelectorAll('[data-yp-lang-switch] input').forEach(input => input.addEventListener('change', () => {
		selectLocale(currentMarket, input.value);
	}));
	let activeDialog = root.querySelector('.v3-title-dialog');
	root.querySelectorAll('.v3-top5-link').forEach((button, index) => button.addEventListener('click', () => {
		const template = document.querySelector(`template[data-yp-title-template="${index}"]`);
		if (!template) return;
		const next = template.content.firstElementChild.cloneNode(true);
		activeDialog.replaceWith(next); activeDialog = next;
		next.querySelector('.v3-title-dialog-close button').addEventListener('click', () => next.close());
		next.querySelector('.v3-title-dialog-cta button').addEventListener('click', () => {next.close(); scrollToCatalog();});
		next.addEventListener('mousedown', event => {if (event.target === next) next.close();});
		next.showModal();
	}));
	const market = root.querySelector('.market-switcher');
	if (market) {
		const trigger = market.querySelector('.market-switcher-trigger');
		const list = market.querySelector('.market-switcher-listbox');
		const options = [...market.querySelectorAll('.market-switcher-option')];
		const setOpen = (open, focus = false) => {
			if (open) market.dataset.open = 'true'; else delete market.dataset.open;
			trigger.setAttribute('aria-expanded', String(open)); list.setAttribute('aria-hidden', String(!open));
			options.forEach(option => option.tabIndex = open ? 0 : -1);
			if (focus) (open ? (options.find(option => option.getAttribute('aria-selected') === 'true') || options[0]) : trigger).focus();
		};
		trigger.addEventListener('click', event => setOpen(!market.dataset.open, event.detail === 0));
		trigger.addEventListener('keydown', event => {if (['ArrowDown','ArrowUp'].includes(event.key)) {event.preventDefault();setOpen(true,true);}});
		document.addEventListener('pointerdown', event => {if (!market.contains(event.target)) setOpen(false);});
		market.addEventListener('keydown', event => {if(event.key === 'Escape') {event.preventDefault();setOpen(false,true);}});
		options.forEach((option,index) => {
			option.addEventListener('click', () => {
				setOpen(false,true);
				const selectedMarket = ['AE','KW','QA'][index];
				if (selectedMarket !== currentMarket) { analytics?.trackMarketChange(currentMarket, selectedMarket); selectLocale(selectedMarket, currentLanguage); }
			});
			option.addEventListener('keydown', event => {
				let target;
				if(event.key === 'ArrowDown') target=(index+1)%options.length;
				if(event.key === 'ArrowUp') target=(index+options.length-1)%options.length;
				if(event.key === 'Home') target=0;
				if(event.key === 'End') target=options.length-1;
				if(target !== undefined){event.preventDefault();options[target].focus();}
				if(event.key === 'Tab') setOpen(false);
			});
		});
	}
})();
